import React, { useState } from 'react';
import { Grid, Card, CardActionArea, CardContent, CardActions, Stack, Typography, Chip, Button } from '@mui/material';
import ExamDetailsModal from './ExamDetailsModal';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PaperCard from './PaperCard';
import { APP_DOWNLOAD } from '../config/appConfig';
import { CATEGORIES } from '../config/categories';

// Helper to labelize category from centralized config
const labelizeCategory = (c) => {
  if (!c) return 'Other';
  const found = CATEGORIES.find(cat => String(cat.id).toLowerCase() === String(c).toLowerCase());
  return found ? found.label : (String(c) || 'Other');
};

export default function ExamsGrid({ exams }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';
  const [attemptExamId, setAttemptExamId] = useState(null);
  return (
    <>
      <Grid container spacing={2}>
        {exams.map((exam, index) => (
          <Grid key={exam.id} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <PaperCard
              paper={{
                ...exam,
                title: exam.name,
                category: labelizeCategory(exam.categoryId),
                year: exam.examYear,
                tags: exam.posts?.slice(0, 2) || []
              }}
              index={index}
              variant="exam"
              onClick={(e) => {
                if (e && e.preventDefault) e.preventDefault();
                setAttemptExamId(exam.id);
              }}
              showAppDownloadQr={APP_DOWNLOAD.enabled && !isAdmin}
              playStoreUrl={APP_DOWNLOAD.playStoreUrl}
              qrImageUrl={APP_DOWNLOAD.qrImageUrl}
              qrSize={APP_DOWNLOAD.qrSize}
              actionButtonText="Explore Exam"
              showDescription={false}
              showTotalMarks={false}
              customFields={exam.stages ? [
                {
                  icon: <Typography variant="caption" color="action">📋</Typography>,
                  text: `${exam.stages} stage${exam.stages > 1 ? 's' : ''}`
                }
              ] : []}
            />
          </Grid>
        ))}
      </Grid>
      <ExamDetailsModal open={!!attemptExamId} examId={attemptExamId} onClose={() => setAttemptExamId(null)} />
    </>
  );
}
